import { render } from "./courseplay.vue?vue&type=template&id=31888b2f&scoped=true&ts=true"
import script from "./courseplay.vue?vue&type=script&lang=ts"
export * from "./courseplay.vue?vue&type=script&lang=ts"

import "./courseplay.vue?vue&type=style&index=0&id=31888b2f&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31888b2f"]])

export default __exports__